export default "__VITE_ASSET__7iX3AZGR__"